// @flow weak

import React, {
  PureComponent
} from 'react';
import PropTypes from 'prop-types';
import AnimatedView from '../../components/animatedView/AnimatedView';
import { button, Link, BrowserRouter, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Children from '../children/Children';

class Tree extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentSubtreeData: [],
      currentFolderID: ""
    };
  }

  componentDidMount() {
    this.getFolders();
  }

  componentWillUnmount() {
  }

  getFolders() {
    var self = this;
    $.ajax({
      // url: args.FBC_URL + "/includes/lib/tree.php?subdomain=" +
      //   args.subdomain + "&app_api=" + args.app_api + "&token=" + args.token + "&wp_abspath=" + args.abspath,
      url: args.FBC_URL + "includes/lib/tree.php?subdomain=" + args.subdomain,
      type: "POST",
      dataType: 'json',
      data: {
        subdomain: args.subdomain,
        app_api: args.app_api,
        token: args.token,
        wp_abspath: args.abspath,
      },
    })
      .done(function (result) {
        result = JSON.parse(result);
        // self.setState({ data: data.results });
        self.setState({ data: result.results });
      });
  }

  handleClick(item, e) {
    var self = this;
    var currentNode = jQuery("#parent_" + item.id);
    var children = jQuery("#parent_" + item.id).find("div").children("ul");
    if (!children.length) {
      currentNode.find("img").removeClass("canto_hidden");
      currentNode.find("i").addClass("canto_hidden");
      $.ajax({
        // url: args.FBC_URL + "/includes/lib/tree.php?subdomain=" +
        //   args.subdomain + "&app_api=" + args.app_api + "&token=" + args.token + "&ablumid=" + item.id + "&wp_abspath=" + args.abspath,
        url: args.FBC_URL + "includes/lib/tree.php?subdomain=" + args.subdomain,
        type: "POST",
        dataType: 'json',
        data: {
          subdomain: args.subdomain,
          app_api: args.app_api,
          token: args.token,
          ablumid: item.id,
          wp_abspath: args.abspath,
        },
      })
        .done(function (subdata) {
          subdata = JSON.parse(subdata);
          self.setState({
            currentSubtreeData: subdata.results,
            currentFolderID: item.id
          }, () => {
            currentNode.find("img").addClass("canto_hidden");
            currentNode.find("i").removeClass("canto_hidden");
          });
        });
    }
    self.toggleFolder(item.id);
    //e.stopPropagation();
  }

  toggleFolder(id) {
    var children = jQuery("#parent_" + id).find("div").children("ul");
    if (children.is(":visible")) {
      jQuery("#parent_" + id + ">i").removeClass("icon-icn_flight_folder_open3");
      jQuery("#parent_" + id + ">i").addClass("icon-icn_flight_folder_01");
      children.css('display', 'none');
      children.hide('fast');
    } else {
      jQuery("#parent_" + id + ">i").removeClass("icon-icn_flight_folder_01");
      jQuery("#parent_" + id + ">i").addClass("icon-icn_flight_folder_open3");
      children.css('display', 'block');
      children.show('fast');
    }
  }

  showFolders(data) {
    var self;
    const folders = [];
    data.map((item, index) => {
      var id = "parent_" + item.id;
      var loader_white = args.FBC_URL + "assets/loader_white.gif";
      // if(item.children) {
      // if (Number(item.size)) {
      if (item.scheme == "folder") {
        if (Number(item.size)) {
          var folder =
            <li className="parent_li first_layer" id={id} key={index}>
              <i className="icon-icn_flight_folder_01" onClick={this.handleClick.bind(this, item)}></i>
              {/* <img src="https://s3-us-west-2.amazonaws.com/static.dmc/universal/icon/cantoloading.gif" className="folder-loading canto_hidden" alt="Loading"></img> */}
              <img src={loader_white} className="folder-loading canto_hidden" alt="Loading"></img>
              <a href="javascript:;" onClick={this.handleClick.bind(this, item)}>
                {item.name}
              </a>
              <Children item={this.state.currentSubtreeData} currentFolderID={this.state.currentFolderID} floderID={item.id} />
            </li>;
        } else {
          var folder =
            <li id={id} key={index}>
              <i className="icon-icn_flight_folder_open3"></i>
              {item.name}
            </li>;
        }
      } else {
        var empty = (item.size == 0) ? { color: "#999999" } : {};
        var folder =
          <li id={id} key={index}>
            <Link to={{ pathname: `/images/${item.id}`, state: { albumName: `${item.name}` } }} style={empty}>
              <i className="icon-icn_album_01" style={empty}></i>
              {item.name}
            </Link>
          </li>;
      }
      folders.push(folder);
    });
    return folders;
  }

  render() {
    var folderTree = (this.state.data.length) ? this.showFolders(this.state.data) : <div><li></li><li></li><li></li><li></li><li></li><li></li><li></li></div>;
    var icon = args.FBC_URL + "assets/canto-icon.png";
    return (
      <div id="fbc-tree" className="collapse">
        <div className="tree well">
          <ul>
            <li>
              <Link to={{ pathname: '/images', state: { albumName: 'Main Library' } }}>
                <img id="fbc-icon" src={icon} />
                Main Library
              </Link>
            </li>
            {folderTree}
          </ul>
        </div>
      </div>
    );
  }
}

export default withRouter(Tree);



// WEBPACK FOOTER //
// ./src/app/views/tree/Tree.js